import { store } from 'reducers';

export const getFlashMessage = (key: string) => {
  const flashMessages = store.getState().loggedInUser.data?.appConfig?.flashMessages || {};
  const messagesWithKey = (flashMessages[key] || []) as Array<string | boolean | number>;
  // Return the first message from array
  return messagesWithKey.length > 0 ? messagesWithKey[0] : '';
};
